export default "__VITE_ASSET__BeOdDFi8__"